var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClubs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "81 208 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii1c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.995 214C148.897 214 153.702 215.352 157.862 217.901C162.023 220.45 165.373 224.094 167.533 228.421C169.693 232.747 170.576 237.582 170.082 242.377C169.587 247.172 167.735 251.735 164.736 255.547C169.1 253.33 174.01 252.361 178.907 252.754C183.803 253.146 188.489 254.882 192.43 257.765C196.372 260.647 199.41 264.561 201.199 269.059C202.988 273.556 203.456 278.458 202.549 283.204C201.643 287.951 199.398 292.351 196.071 295.904C192.744 299.458 188.468 302.021 183.731 303.301C178.994 304.582 173.987 304.529 169.28 303.148C164.572 301.766 160.354 299.113 157.106 295.49V304.222L162.079 323.778C162.882 326.936 160.474 330 157.189 330H130.8C127.516 330 125.108 326.936 125.911 323.778L130.884 304.222L130.89 295.49C127.642 299.112 123.423 301.764 118.716 303.144C114.009 304.525 109.002 304.577 104.266 303.296C99.5293 302.015 95.2544 299.452 91.9279 295.899C88.6013 292.345 86.3569 287.945 85.4504 283.199C84.5439 278.453 85.0117 273.552 86.8005 269.055C88.5893 264.557 91.6272 260.644 95.5681 257.761C99.5089 254.879 104.194 253.142 109.09 252.749C113.986 252.357 118.896 253.324 123.26 255.541C120.263 251.729 118.413 247.167 117.919 242.374C117.426 237.581 118.308 232.747 120.467 228.422C122.626 224.097 125.975 220.453 130.133 217.904C134.292 215.355 139.094 214.002 143.995 214Z",
    fill: "#1B191A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.995 214C148.897 214 153.702 215.352 157.862 217.901C162.023 220.45 165.373 224.094 167.533 228.421C169.693 232.747 170.576 237.582 170.082 242.377C169.587 247.172 167.735 251.735 164.736 255.547C169.1 253.33 174.01 252.361 178.907 252.754C183.803 253.146 188.489 254.882 192.43 257.765C196.372 260.647 199.41 264.561 201.199 269.059C202.988 273.556 203.456 278.458 202.549 283.204C201.643 287.951 199.398 292.351 196.071 295.904C192.744 299.458 188.468 302.021 183.731 303.301C178.994 304.582 173.987 304.529 169.28 303.148C164.572 301.766 160.354 299.113 157.106 295.49V304.222L162.079 323.778C162.882 326.936 160.474 330 157.189 330H130.8C127.516 330 125.108 326.936 125.911 323.778L130.884 304.222L130.89 295.49C127.642 299.112 123.423 301.764 118.716 303.144C114.009 304.525 109.002 304.577 104.266 303.296C99.5293 302.015 95.2544 299.452 91.9279 295.899C88.6013 292.345 86.3569 287.945 85.4504 283.199C84.5439 278.453 85.0117 273.552 86.8005 269.055C88.5893 264.557 91.6272 260.644 95.5681 257.761C99.5089 254.879 104.194 253.142 109.09 252.749C113.986 252.357 118.896 253.324 123.26 255.541C120.263 251.729 118.413 247.167 117.919 242.374C117.426 237.581 118.308 232.747 120.467 228.422C122.626 224.097 125.975 220.453 130.133 217.904C134.292 215.355 139.094 214.002 143.995 214Z",
    fill: "url(#paint0_linear1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii1c",
    x: 85,
    y: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear1",
    x1: 128.564,
    y1: 214,
    x2: 128.564,
    y2: 330,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343434",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubs);
export default __webpack_public_path__ + "static/media/clubs.a1f0d1b5804ccea89730a86428aeeeab.svg";
export { ForwardRef as ReactComponent };